import { render, staticRenderFns } from "./downloadComponent.vue?vue&type=template&id=b6bea97e&scoped=true&"
import script from "./downloadComponent.vue?vue&type=script&lang=js&"
export * from "./downloadComponent.vue?vue&type=script&lang=js&"
import style0 from "./downloadComponent.vue?vue&type=style&index=0&id=b6bea97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6bea97e",
  null
  
)

export default component.exports